import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ImageUploadProps {
  files: FileList | null;
  onChange: (files: FileList | null) => void;
  onRemove?: (index: number) => void;
  previewUrls?: string[];
  error?: string;
  multiple?: boolean;
  accept?: string;
  className?: string;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  files,
  onChange,
  onRemove,
  previewUrls = [],
  error,
  multiple = true,
  accept = 'image/jpeg,image/png,image/gif,image/heic,image/heif,.heic,.heif',
  className = ''
}) => {
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      onChange(event.target.files);
    } else {
      onChange(null);
    }
  };

  return (
    <div>
      {/* Image Previews */}
      {previewUrls.length > 0 && (
        <div className="mb-4">
          <label className="block mb-2 font-medium text-gray-700">
            Selected Images
          </label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {previewUrls.map((url, index) => (
              <div key={index} className="relative">
                <img
                  src={url}
                  alt={`Preview ${index + 1}`}
                  className="w-full h-32 object-cover rounded-lg"
                />
                {onRemove && (
                  <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 transition duration-300"
                  >
                    <XMarkIcon className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* File Input */}
      <input
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleImageChange}
        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition duration-300 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${className}`}
      />
      {files && files.length > 0 && (
        <p className="mt-2 text-sm text-gray-600">
          {files.length} file(s) selected
        </p>
      )}
      {error && (
        <span className="text-red-500 text-sm mt-1 block">{error}</span>
      )}
    </div>
  );
};

export default ImageUpload;
